import { toValue } from "vue";
import { hash } from "ohash";
import { flatMapDeep } from "lodash-es";
export default (thing) => {
  return hash(
    flatMapDeep(
      thing,
      (value, index) => [index, toValue(value)]
    )
  );
};
